import { get } from '../Utils/index';

export const searchOptions = () => {
  return get(`/customer/search`);
};

export const searchApi = {
  searchOptions,
};
